<template>
  <v-app>
    <v-main>
      <v-progress-linear v-if="isLoading" indeterminate />
      <template v-else>
        <HeaderBar
          v-if="isAuthenticatedReactive && showHeader"
          @toggle-sidebar="mobileSidebarOpen = !mobileSidebarOpen"
        />
        <SideBar
          v-if="isAuthenticatedReactive && showSidebar"
          v-model="mobileSidebarOpen"
        />
        <router-view></router-view>
      </template>
    </v-main>
  </v-app>
</template>

<script>
import HeaderBar from './components/HeaderBar.vue';
import SideBar from './components/SideBar.vue';
import { jwtDecode } from 'jwt-decode';

function jwtDecodeFallback(token) {
  try {
    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const payload = decodeURIComponent(
      atob(base64)
        .split('')
        .map(c => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
        .join('')
    );
    return JSON.parse(payload);
  } catch (e) {
    return null;
  }
}

export default {
  components: { HeaderBar, SideBar },
  data() {
    return {
      isLoading: true,
      isAuthenticatedReactive: false,
      isAuthenticated: false,
      mobileSidebarOpen: false,
    };
  },
  computed: {
    showHeader() {
      if (this.$route.path === '/model-schedule' && this.$route.query.compare === '1') return false;
      try {
        const user = JSON.parse(localStorage.getItem('user') || '{}');
        if (user.role === 'model') return false;
      } catch {
        // Fall through to the normal route-based header behavior.
      }
      return this.$route.matched.some(route => route.meta?.requiresAuth);
    },
    showSidebar() {
      if (this.$route.path === '/model-schedule' && this.$route.query.compare === '1') return false;
      try {
        const user = JSON.parse(localStorage.getItem('user') || '{}');
        if (['hr', 'accountant', 'model'].includes(user.role)) return false;
      } catch {
        // Use normal route-based sidebar behavior when stored user data is malformed.
      }
      const protectedRoutes = [
        '/dashboard',
        '/models',
        '/sales',
        '/reports',
        '/adjustments',
        '/hours',
        '/calendar',
        '/tasks',
        '/payments',
        '/configuration',
        '/accounts-access',
        '/inventory',
        '/card-expenses',
        '/cash-box',
        '/model-schedule',
        '/weekly-sales',
        '/admin-schedule',
        '/periods',
      ];
      return protectedRoutes.includes(this.$route.path);
    },
  },
  methods: {
    checkTokenValidity() {
      const token = localStorage.getItem('authToken');
      if (!token) return false;
      let tokenToDecode = token;
      if (typeof token === 'string' && token.length > 1 && token.startsWith('"') && token.endsWith('"')) {
        tokenToDecode = token.substring(1, token.length - 1);
      }
      try {
        let decoded;
        try {
          decoded = jwtDecode(tokenToDecode);
        } catch (decodeError) {
          decoded = jwtDecodeFallback(tokenToDecode);
        }
        if (!decoded) {
          return false;
        }
        const currentTime = Math.floor(Date.now() / 1000);
        if (decoded.exp < currentTime) {
          localStorage.removeItem('authToken');
          return false;
        }
        return true;
      } catch {
        localStorage.removeItem('authToken');
        return false;
      }
    }
  },
  watch: {
    '$route.path'() {
      this.mobileSidebarOpen = false;
      this.isAuthenticated = this.checkTokenValidity();
      this.isAuthenticatedReactive = this.isAuthenticated;
    }
  },
  mounted() {
    this.$router.isReady().then(() => {
      setTimeout(() => {
        this.isAuthenticated = this.checkTokenValidity();
        this.isAuthenticatedReactive = this.isAuthenticated;
        this.isLoading = false;
      }, 300);
    });
  },
};
</script>
